import { ContentContainer, LoadingSpinner } from '../components/Generic'
import axios from 'axios'
import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { StoreContext } from '../components/App'

import { Intro } from '../components/ResumeFromEmail/steps/IntroPage'
import { Otp } from '../components/ResumeFromEmail/steps/OtpPage'
import { Error } from '../components/ResumeFromEmail/steps/ErrorPage'

import { devLog } from '../methods/devLog'
import { getQueryVariable } from '../methods/getQueryVariable'

export interface GetResumeFromEmailContextResponse {
  maskedPhoneNumber: string
  sendResumptionEndpoint: string
  enterResumptionEndpoint: string
  resumeWithOtpEndpoint: string
  otpMaxAttempts: number
  smsMaxAttempts: number
  smsRetrySeconds?: number
}

export const ResumeFromEmailPage = observer(() => {
  const store = useContext(StoreContext)
  const { theme } = store.InterfaceState
  const apiUrl = process.env.WEB_API_URL

  const [step, setStep] = useState(0)
  const [attemptsLeft, setAttemptsLeft] = useState<number | undefined>(
    undefined
  )
  const [context, setContext] = useState<
    GetResumeFromEmailContextResponse | undefined
  >()

  const nextStep = () => {
    setStep(step + 1)
  }

  const initComponent = async () => {
    const otpAttemptsLeft = getQueryVariable('otpAttemptsLeft')

    try {
      const { data } = await axios.get<GetResumeFromEmailContextResponse>(
        `${apiUrl}/${process.env.ONBOARDING_WEB_API_PATH}/get-resume-transaction-context`,
        {
          withCredentials: true,
        }
      )

      devLog(data)
      setContext(data)

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!otpAttemptsLeft) {
        setAttemptsLeft(Number(otpAttemptsLeft))
        setStep(Number(otpAttemptsLeft) === 0 ? 3 : 2)
      } else {
        nextStep()
      }
    } catch (error) {
      devLog(error)
      setStep(3)
    }
  }

  useEffect(() => {
    devLog('initComponent')
    void initComponent()
  }, [])

  const renderCurrentStep = () => {
    if (!context) {
      if (step === 3) return <Error />

      return (
        <LoadingSpinner
          width="68px"
          padding="100px 0"
          {...theme.loadingSpinner}
        />
      )
    }

    switch (step) {
      case 0:
        return (
          <>
            <LoadingSpinner
              width="68px"
              padding="100px 0"
              height="400px"
              {...theme.loadingSpinner}
            />
          </>
        )
      case 1:
        return (
          <Intro
            nextStep={nextStep}
            phoneNumber={context.maskedPhoneNumber}
            sendOtpUrl={context.sendResumptionEndpoint}
          />
        )
      case 2:
        return (
          <Otp
            nextStep={nextStep}
            maxAttempts={context.otpMaxAttempts}
            attemptsLeft={attemptsLeft}
            verifyOtpUrl={context.enterResumptionEndpoint}
            formActionUrl={context.resumeWithOtpEndpoint}
            sendOtpUrl={context.sendResumptionEndpoint}
            smsMaxAttempts={context.smsMaxAttempts}
            smsRetrySeconds={context.smsRetrySeconds}
            isSmsEnabled={true}
          />
        )
      case 3:
        return <Error />

      default:
        return <></>
    }
  }

  return (
    <ContentContainer
      {...theme.container}
      width="560px"
      paddingMobile="20px"
      marginMobile="0"
    >
      {renderCurrentStep()}
    </ContentContainer>
  )
})
